import { BirthdayDocument } from 'shell/view-models/birthday-document';
import { AccordionFamilyCoexistence } from 'shell/view-models/accordion-family-coexistence';
import { EditDataControl } from 'subscription/view-models/common-interface-subscription';

export const InitialValuesBirthdayDocument: BirthdayDocument = {
  documentDate: null,
  documentNumber: '',
  istatCode: '',
  location: '',
  municipality: undefined,
  portion: '',
  serie: '',
  townHallOffice: '',
  volume: '',
  year: '',
};

export const InitialValuesAccordionFamilyCoexistence: AccordionFamilyCoexistence = {
  bondDate: null,
  codeIstat: '',
  coexistenceBond: '',
  cohabitingFamily: '',
  descrizioneCodiceLegame: '',
  especiallyCoexistence: '',
  especiallyCoexistenceDescription: '',
  familyAire: '',
  familyComponents: undefined,
  handlingType: '',
  identifierAnpr: '',
  membershipDate: null,
  municipalityIdentifier: '',
  nameCoexistence: '',
  originDate: null,
  progComponent: '',
  reasonConstitution: '',
  relationship: '',
  tipoScheda: '',
  type: '',
};

export const InitialValuesEditDataControl: EditDataControl = {
  applicationName: '',
  applicationSupplier: '',
  applicationVersion: '',
  assume: '',
  dateDefinitionFile: '',
  datetimeRequest: '',
  dateValidity: null,
  flag: '',
  mutationReason: undefined,
  operation: undefined,
  operationIdAnpr: '',
  operationIdMunicipality: undefined,
  operationResult: '',
  operationType: '',
  protocol: '',
  protocolDate: '',
  receiverId: '',
  requested: '',
  senderId: '',
  sendType: '',
  subscribeTo: '',
};
